<template>
<modal :show="show" @close="close">
    <div class="modal-header">
        <h5 class="modal-title">{{title}}</h5>
        <button @click="close" type="button" class="close">
            <i class="icon icon-close"></i>
        </button>
    </div>

	<div class="modal-body">
    	<slot></slot>
	</div>

    <div class="modal-footer">
        <button @click="close">
            {{cancelText}}
        </button>
        <button class="confirm-button" @click="confirm">
            {{confirmText}}
        </button>
    </div>
</modal>
</template>

<script>
import Modal from "@/../submodules/vue-base/components/Modal";
export default {

    name: 'HtmlConfirmModal',

    props: {
        title: '',
        confirmText: {
            type: String,
            default: "Confirm"
        },
        cancelText: {
            type: String,
            default: "Cancel"
        },
    },

    components: {
        Modal
    },

    data() {
        return {
            show: false
        }
    },

    methods: {
        open() {
            this.show = true;
        },

        close() {
            this.show = false;
            this.$emit('close');
        },

        confirm() {
            this.show = false;
            this.$emit('confirm');
        }
    }

}
</script>
